import { render, staticRenderFns } from "./TheLayoutContent.vue?vue&type=template&id=6155c1ee&"
import script from "./TheLayoutContent.vue?vue&type=script&lang=js&"
export * from "./TheLayoutContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports